import React from 'react';

import { Text } from '~/components/blocks';
import { ExternalLink } from '~/components/blocks/ExternalLink';
import { splitText } from '~/utils/split_text';

// 薬師丸賢太 API の verify エラー時に返る
// `api/config/locales/ja.yml` の `verify_yakumaru_api.invalid_setting_with_pharmacy_code`
// (「薬局コードが一致しません。設定内容をご確認ください」) を Alert 内で表示するときに使う。
// メッセージ中の「設定内容」を、薬局コードを登録できる画面 (settingsPath) への外部リンクに置換する。
// 遷移先は本部側 (/company/organizations/settings) と店舗側 (/settings/organization) で異なるため props で受ける。
const SETTINGS_LINK_KEYWORD = '設定内容';

type Props = {
  message: string;
  settingsPath: string;
};

export const YakumaruSettingsErrorMessage: React.FC<Props> = ({ message, settingsPath }) => {
  const { before, keyword, after } = splitText(message, SETTINGS_LINK_KEYWORD);

  if (keyword === '') return <Text size="s">{message}</Text>;

  return (
    <Text size="s">
      {before}
      <ExternalLink url={settingsPath}>{keyword}</ExternalLink>
      {after}
    </Text>
  );
};
